var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"my-2",attrs:{"outlined":"","color":"secondary","small":""},on:{"click":function($event){$event.stopPropagation();return _vm.download()}}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-download")]),_c('span',[_vm._v("CSV")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }